'use client';

import { c as _c } from "react/compiler-runtime";
import Link from 'next/link';
import { ArrowRight } from 'lucide-react';
import { FeedCarousel } from '@/components/ui/feed-carousel';
import { ExampleCard } from '@/components/demand/ExampleCard';
import { FEED_EXAMPLES } from '@/components/demand/feed-examples-data';
export function DemandFeedSection() {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="mx-auto max-w-[1320px] px-5 sm:px-8 lg:px-12"><div><h3 className="text-2xl font-black tracking-tight text-gray-900 sm:text-3xl">Real examples. Get inspired, make your next moves.</h3></div></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <FeedCarousel className="mt-8" exploreMore={{
      href: "/inspiration-feed",
      label: "Explore More Inspiration"
    }}>{FEED_EXAMPLES.map(_temp)}</FeedCarousel>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <section className="relative overflow-hidden bg-white py-16 sm:py-20 lg:py-24">{t0}{t1}<div className="mx-auto mt-10 max-w-[1320px] px-5 text-center sm:px-8 lg:px-12"><Link href="/inspiration-feed" className="inline-flex cursor-pointer items-center gap-2 rounded-full bg-[#ff5a36] px-7 py-3.5 text-base font-black text-white shadow-lg shadow-red-500/20 transition-all hover:-translate-y-0.5 hover:shadow-xl hover:shadow-red-500/30">Inspiration Feed<ArrowRight className="h-4 w-4" aria-hidden="true" /></Link></div></section>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}
function _temp(item) {
  return <ExampleCard key={item.example.id} example={item.example} variant={item.variant} postMeta={item.postMeta} analysis={item.analysis} />;
}